import { api } from '../utils/api';

export interface WaitlistPayload {
  email: string;
  consent: boolean;
  sourcePath?: string;
  utm?: string;
  createdAt?: string;
}

export const submitWaitlist = (payload: WaitlistPayload) => {
  return api.post('/waitlist', payload);
};
